var map = {
	"./ost_1.png": 1037,
	"./ost_11.png": 1038,
	"./ost_12.png": 1039,
	"./ost_15.png": 1040,
	"./ost_16.png": 1041,
	"./ost_2.png": 1042,
	"./ost_3.png": 1043,
	"./ost_4.png": 1044,
	"./ost_5.png": 1045,
	"./ost_8.png": 1046
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1036;


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img ^\.\/ost_.*\.png$
// module id = 1036
// module chunks = 0